<template>
    <div class="editable_list_item" :class="{ disabled_item: $props.disabled===true }">
        <div class="item_title">FAQ</div>
        <div v-show="isAdding">
            Selecione os items que você deseja que apareçam na lista.
            <table>
                <thead>
                    <tr>
                        <th>&nbsp;</th>
                        <th>Pergunta</th>
                        <th>Resposta</th>
                        <th>&nbsp;</th>
                    </tr>
                </thead>
                <tbody >
                    <tr v-for="(element, index) in all" :key="index" class="item">
                        <td><v-switch v-model="element.selected"></v-switch></td>
                        <td>
                            {{element.question}}
                        </td>
                        <td>
                            <div class="anwser-content" v-html="element.anwser"></div>
                        </td>
                        <td class="editCol">
                            <button class="flake-btn" @click="edit(index)"><i class="material-icons">edit</i></button>
                        </td>

                    </tr>
                </tbody>
            </table>

            <button class="fluke-btn" @click="save">Selecionar itens</button>
            <button class="fluke-btn fluke-grey" @click="cancel('adding')">Cancelar</button>
        </div>
        <div v-show="isEditing">
            <br />
            <v-text-field label="Pergunta" v-model="current.question"></v-text-field>
            <v-text-field label="Resposta" v-model="current.anwser"></v-text-field>

            <button class="fluke-btn" @click="save">Salvar</button>
            <button class="fluke-btn fluke-grey" @click="cancel('editing')">Cancelar</button>
        </div>
        <div v-show="!isEditing && !isAdding">
            <table>
                <thead>
                    <tr>
                        <th>&nbsp;</th>
                        <th>Pergunta</th>
                        <th>Resposta</th>
                    </tr>
                </thead>
                <draggable v-model="items" tag="tbody" handle=".handle" @change="reorder">
                    <tr v-for="(element, index) in items" :key="index" class="item">
                        <td><i class="material-icons" :class="{ handle: $props.disabled!==true }">reorder</i></td>
                        <td>
                            {{element.question}}
                        </td>
                        <td>
                            <div class="anwser-content" v-html="element.anwser"></div>
                        </td>
                    </tr>
                </draggable>
            </table>

            <div id="mi_theysay_add_button">
                <button class="fluke-btn" @click="add" v-if="$props.disabled!==true">Editar items</button>
            </div>
        </div>
    </div>
</template>

<script>
import draggable from 'vuedraggable';
import axios from 'axios';

export default {
    props: [ 'disabled' ],
    components: {
        draggable
    },
    data() {
        return {
            isEditing: false,
            isAdding: false,
            current: {
                question: '',
                anwser: '',
                id: 0
            },
            all: [],
            items: []
        }
    },
    created() {
        this.getData();
    },
    methods: {
        async getData(){
            var courseId = this.$route.params.id;

            const result = await axios.get(
                this.$myServerAddresses.courses + 'faq/list_by_course/' + courseId,
                {
                    headers: {
                        'X-Fluke': this.$cookies.get('token')
                    }
                }
            );

            this.items = result.data;
            this.$store.commit('set_course_faq', this.items);
        },
        cancel(action){
            if( action == 'adding' ){
                this.isAdding = false;
            } else {
                this.isEditing = false;
                this.isAdding = true;
            }
        },
        async save(){
            if(this.isEditing){

                const result = await axios.put(
                    this.$myServerAddresses.courses + 'faq',
                    {
                        id: this.current.id,
                        question: this.current.question,
                        anwser: this.current.anwser
                    },
                    {
                        headers: {
                            'X-Fluke': this.$cookies.get('token')
                        }
                    }
                );

                this.all = this.all.map( ( el ) => {
                    if( this.current.id == el.id ) {
                        el.anwser = this.current.anwser;
                        el.question = this.current.question;
                        return el;
                    } else {
                        return el
                    }
                });
                this.isEditing = false;
                this.isAdding = true;
            } else {
                this.isAdding = false;
            }
            this.items = this.all.filter( el => el.selected );
            this.$store.commit('set_course_faq', this.items);
        },
        reorder(){
            this.$store.commit('set_course_faq', this.items);
        },
        async add() {
            this.isAdding = true;

            const result = await axios.get(
                    this.$myServerAddresses.courses + 'faq', {
                        headers: {
                            'X-Fluke': this.$cookies.get('token')
                        }
                    }
            );
            this.all = result.data.map(el => {
                el.selected = this.items.find(elem => elem.id == el.id)?true:false;
                return el;
            });
        },
        edit(index) {
            this.isEditing = true;
            this.isAdding = false;

            var { anwser, question, id } = this.all.find( ( el,idx ) => {
                return ( index == idx );
            });
            this.current.anwser = anwser;
            this.current.question = question;
            this.current.id = id;
        },
        remove(index) {
            this.items = this.items.filter( ( el,idx ) => {
                return !( index == idx );
            });
        }
    }
}
</script>

<style lang="scss">
.anwser-content {
    img {
        max-width: 100%;
        display: block;
    }
}
</style>
